export default "__VITE_ASSET__nvhWO5ZH__"